module.exports = __webpack_public_path__ + "img/jmfc003.9cd0f923.png";